const data = [
  {
    label: 'HOME',
    to: '/',
  },
  {
    label: 'ABOUT',
    to: '/about',
  },
  {
    label: 'PORTFOLIO',
    to: '/portfolio',
  },
  {
    label: 'SKILLS',
    to: '/skills',
  },
  {
    label: 'CONTACT',
    to: '/contact',
  },
];

export default data;
